/// <amd-module name="Test/Analytics/Common/Actions/AnnouncementActions" />
import { Action } from "VSS/Reflux/Action";

export class AnnouncementActions {
    public announceAction: Action<string> = new Action<string>();
}
